import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { SignInChallenge } from '@egw/features-auth'

export const SignInChallengePage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.sign-in_challenge.title')} />
      <SignInChallenge />
    </Layout>
  )
}
